import TabulerView from './TabulerView'
import useTranslations from '../../../../../hooks/useTranslations'
import ANTDCard from '../../../../../shared/antd/ANTDCard'
import { userWiseRole } from '../../../../../utils/constant'
import { length, keys } from '../../../../../utils/javascript'
import JobUserSelect from '../../common/JobUserSelect'

const InspectionDetailsView = ({ inspectionData, currentForm }) => {
  const { t } = useTranslations()
  const { anganwadiCenter } = userWiseRole

  return (
    <ANTDCard className="mb-15">
      <h2 className="content-title mb-10">{t('job_InspectionDetails')}</h2>
      {inspectionData?.map((details, index) => (
        <ANTDCard key={index} className="grey-card-body elv-card">
          <JobUserSelect
            {...{
              selectTitle: 'user_AnganwadiCenter',
              roleId: anganwadiCenter,
              userData: length(keys(details?.anganwadiCenter))
                ? [details?.anganwadiCenter]
                : [],
              readOnly: true,
            }}
          />

          <TabulerView
            inspectionDetails={details}
            // userSelectionList={userSelectionList}
            currentForm={currentForm}
            inspectionIndex={index}
          />
        </ANTDCard>
      ))}
    </ANTDCard>
  )
}

export default InspectionDetailsView
